<template>
  <div class="marquee" ref="container">
    <div class="marquee__inner">
      <div class="marquee__items" v-bind:style="{ animationDuration }">
        <div
          v-for="(item, i) in marqueeItems"
          :key="`item-${i}`"
          v-html="item.name"
          v-bind:style="{ textIndent }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      textIndent: 1000,
    };
  },
  computed: {
    animationDuration() {
      const factor = ['xs', 'sm', 'md', 'lg', 'xl'].map((bp, i) => [bp, Math.sqrt(i + 1) * 9]).find(([bp]) => this.$vuetify.breakpoint.name === bp)[1];
      const time = Math.round(parseFloat(this.textIndent) / factor);
      console.log('factor', factor, 'textIndent', parseFloat(this.textIndent), 'time', time);
      return `${time}s`;
    },
    marqueeItems() {
      if (this.items.length !== 1) {
        return this.items;
      }
      return [this.items[0], this.items[0]];
    },
  },
  mounted() {
    this.textIndent = `${this.$refs.container.offsetWidth}px`;
    this.$watch(() => this.$vuetify.breakpoint.width, () => {
      this.textIndent = `${this.$refs.container.offsetWidth}px`;
    });
  },
};
</script>

<style lang="scss" scoped>
  $bounds-spacing: 0.5rem;

  .marquee {
    overflow: hidden;
    position: relative;
    height: 3rem;
    border: 1px solid #dedede;

    > .marquee__inner {
      position: absolute;
      left: $bounds-spacing;
      right: $bounds-spacing;
      top: $bounds-spacing;
      bottom: $bounds-spacing;
      overflow: hidden;

      > .marquee__items {
        animation: marquee 30s linear infinite;
        display: table;
        white-space: nowrap;
        transform: translateX(-50%);

        & > div {
          white-space: nowrap;
          display: inline-block;
          line-height: 2rem;
        }
      }
    }

    &:hover > .marquee__inner > .marquee__items {
      animation-play-state: paused;
    }

  }

  @keyframes marquee {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }
</style>
